<template>
  <div class="member-password-picker">
    <van-popup v-model="visible" position="bottom">
      <div class="member-password-box">
        <div
          class="select-head van-hairline--top-bottom van-picker__toolbar"
          style="margin-bottom:10px;"
        >
          <button class="van-picker__cancel" @click="cancel">取消</button>
          <span>{{ title }}</span>
          <button class="van-picker__confirm" @click="onConfirm">确认</button>
        </div>
        <div class="title" v-if="showMoney">
          消费金额：<span class="price">{{ money }}</span>
        </div>
        <div class="input">
          <van-field
            v-model="value"
            type="password"
            style="border:1px solid #ddd;"
            autofocus
          />
        </div>
        <div style="height:5.76rem;"></div>
        <!-- <van-password-input
          :value="value"
          :length="6"
          :gutter="15"
          style="margin-bottom:16px;"
        />
        <div style="height:5.76rem;">
          <van-number-keyboard
            :show="true"
            :transition="false"
            @input="onInput"
            @delete="onDelete"
          />
        </div> -->
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup, PasswordInput, NumberKeyboard, Field, Notify } from "vant";
import { memberPasswordVerif } from "@/api/member.js";
import md5 from "js-md5";
export default {
  name: "SelectMultiplePicker",
  components: {
    [Popup.name]: Popup,
    [PasswordInput.name]: PasswordInput,
    [NumberKeyboard.name]: NumberKeyboard,
    [Field.name]: Field,
  },
  props: {
    title: {
      type: String,
      default: "请输入支付密码",
    },
    showMoney: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: "50%",
    },
    money: {
      type: [String, Number],
      default: "",
    },
    MemberCardId: {
      type: [String, Number],
      required: true,
    },
    success: { type: Function },
    error: { type: Function },
  },
  data() {
    return {
      visible: false,
      value: "",
    };
  },
  created: function() {},
  mounted() {
    this.visible = true;
  },

  methods: {
    onInput(key) {
      this.value = (this.value + key).slice(0, 6);
    },
    onDelete() {
      this.value = this.value.slice(0, this.value.length - 1);
    },
    onConfirm() {
      if (!this.MemberCardId) {
        Notify({ type: "danger", message: "缺少必要参数" });
        return false;
      }

      //验证密码
      memberPasswordVerif({
        MemberCardId: this.MemberCardId,
        Password: md5(this.value),
      })
        .then(() => {
          this.$emit("success", this.value);
          this.cancel();
        })
        .catch(() => {
          this.$emit("error");
        });

      // this.$emit("change", this.value);
      // this.cancel();
    },
    cancel() {
      this.visible = false;
      this.$emit("destroy");
    },
  },
};
</script>

<style lang="less" scoped>
.member-password-box {
  // height: 50vh;
  // background: #f1f1f1;
  .title {
    text-align: center;
    padding: 16px;
    .price {
      color: red;
    }
  }
  .input {
    padding: 0 16px 16px 16px;
  }
}
</style>
